var React = require('react');

function InfoMono (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface22797316"},React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(100%,100%,100%)","fillOpacity":"1"},"d":"M 12 2 C 6.476562 2 2 6.476562 2 12 C 2 17.523438 6.476562 22 12 22 C 17.523438 22 22 17.523438 22 12 C 22 6.476562 17.523438 2 12 2 Z M 12 17 C 11.449219 17 11 16.550781 11 16 L 11 12 C 11 11.449219 11.449219 11 12 11 C 12.550781 11 13 11.449219 13 12 L 13 16 C 13 16.550781 12.550781 17 12 17 Z M 12.5 9 L 11.5 9 C 11.222656 9 11 8.777344 11 8.5 L 11 7.5 C 11 7.222656 11.222656 7 11.5 7 L 12.5 7 C 12.777344 7 13 7.222656 13 7.5 L 13 8.5 C 13 8.777344 12.777344 9 12.5 9 Z M 12.5 9 "})));
}

InfoMono.defaultProps = {"viewBox":"0 0 24 24","width":"24px","height":"24px"};

module.exports = InfoMono;

InfoMono.default = InfoMono;
